import {
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
  TIContainerInformationExtendedValid,
} from "@tedivo/tedivo-bay-grid-pure";

import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";

export function getAllContainers(
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
): TGetContainersFilterOutput {
  const { gridContent, allStacksKeys, allTiersKeys } = smartBay.getGridContent();
  const containers: TIContainerInformationExtendedValid[] = [];

  for (const tierKey of allTiersKeys) {
    for (const stackKey of allStacksKeys) {
      const currContent = gridContent[stackKey]?.[tierKey];

      if (!currContent) continue;

      containers.push(...(currContent.containers as TIContainerInformationExtendedValid[]));
    }
  }

  return {
    containers,
    tBaysStr: smartBay.tBaysStr,
    level: smartBay.level,
  };
}
